import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';
import { map } from 'rxjs/operators';
import { Profissional } from '../api';

@Injectable({
  providedIn: 'root',
})
export class ProfissionalSectorService {
  private readonly path = 'profissionais';
  public params = new HttpParams();
  private apiVagas = `${environment.apiProfissionaisUrl.replace(/\/+$/, '')}/profissionais`;

  constructor(private apiService: ApiService, private http: HttpClient) {}

  // List all Profissional do sector
  getAllProfissionalGet(params?: any): Observable<any> {
    return this.apiService
      .get<{ data: Profissional[] }>(
        `${this.path}/getAllProfissional`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params,
        true // <- força o uso da URL secundária
      )
      .pipe(
        // debounceTime(500),
        map((response) => response)
      );
  }

  // Get Profissional by ID
  public show(id: string): Observable<Profissional> {
    return this.apiService
      .get<{ data: Profissional }>(
        `${this.path}/getProfissionalById/${id}`,
        new HttpParams(),
        true // URL secundária
      )
      .pipe(map((response) => response.data as Profissional));
  }

  // Create new Profissional do sector
  public store(formData: FormData): Observable<any> {
    return this.apiService.post<any>(
      `${this.path}/AddProfissional`,
      formData,
      {}, // ou `undefined` se seu ApiService não exigir esse parâmetro
      true // true = usa a URL secundária
    );
  }

  // Update existing Profissional do sector
  public update(formData: FormData, id: string): Observable<any> {
    return this.apiService.put(
      `${this.path}/UpdateProfissional/`,
      formData,
      undefined,
      true // URL secundária
    );
  }

  // Delete existing Profissional do sector
  public delete(id: string): Observable<any> {
    return this.apiService.delete(
      `${this.path}/DeleteProfissionalById/${id}`,
      new HttpParams(),
      true // URL secundária
    );
  }

  // get photo Empresa do sector
  getPhotoProfissionalIdGet(id: number): Observable<Blob> {
    return this.apiService.get(
      `${this.path}/getPhotoProfissional/${id}`,
      new HttpParams(),
      true,
      'blob'
    );
  }

  /** GET /profissionais/GerarComprovativo?VagaId=... (espera query params) */
  gerarComprovativo(params: {
    VagaId: number | string;
    [k: string]: any;
  }): Observable<Blob> {
    const headers = new HttpHeaders().set('Accept', 'application/pdf');

    return this.http.get(`${this.apiVagas}/GerarComprovativo`, {
      headers,
      params: this.getParams(params),
      responseType: 'blob',
    });
  }

  /**
   * POST /profissionais/api/KeyKloakController/usuarios/validar?email=...
   * (sem body, só query param `email`)
   */
  validar(email: string): Observable<any> {
    const base = `${this.path}/api/KeyKloakController/usuarios/validar`;
    const query = this.getParams({ email }).toString(); // encoda o email
    return this.apiService.post(`${base}?${query}`, {}, {}, true);
  }

  /*getPhotoEmpresaIdGet(id: number): Observable<Blob> {
    return this.apiService.get(`${this.path}/getPhotoEmpresa/${id}`,
      new HttpParams(),
      true // URL secundária
    );
  }*/

  private getParams(params?: any): HttpParams {
    return params ? new HttpParams({ fromObject: params }) : new HttpParams();
  }
}
